import { paramCase } from 'change-case'

const doc = document.documentElement
const docStyle = doc.style

const CSSVariables = {
  set: (key, value) => {
    docStyle.setProperty(`--${paramCase(key)}`, value)
  }
}

export default {
  install (vue, options) {
    Object.keys(options).forEach(key => CSSVariables.set(key, options[key]))
    vue.prototype.$cssVariables = CSSVariables
  }
}
